module.exports = __webpack_public_path__ + "static/media/f_logo_RGB-Black_512.682d8aca.png";